import React from "react";

interface StepProgressProps {
  totalSteps: number;
  currentStep: number;
  completedSteps: number[];
}

const StepProgress: React.FC<StepProgressProps> = ({
  totalSteps,
  currentStep,
  completedSteps,
}) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  return (
    <div className="p-2">
      <div className="d-flex align-items-center justify-content-center mb-5 flex-wrap gap-1">
        {steps.map((stepNumber, i) => {
          const isCompleted = completedSteps.includes(stepNumber);
          const isCurrent = stepNumber === currentStep;

          return (
            <React.Fragment key={stepNumber}>
              <div
                className="d-flex flex-column align-items-center"
                style={{ width: "60px" }}
              >
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 700,
                    fontSize: "16px",
                    flexShrink: 0,
                    backgroundColor: isCompleted
                      ? "#1e8a4c"
                      : isCurrent
                        ? "#d2660d"
                        : "#f2f3f6",
                    color: isCompleted || isCurrent ? "#ffffff" : "#9aa0ac",
                    border: isCurrent ? "3px solid #fbd7ad" : "none",
                    boxShadow: isCurrent
                      ? "0 0 0 3px rgba(210, 102, 13, 0.12)"
                      : "none",
                    transition: "all 0.2s ease",
                  }}
                >
                  {isCompleted ? <i className="ti ti-check"></i> : stepNumber}
                </div>

                <span
                  className="mt-2"
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: isCompleted
                      ? "#1e8a4c"
                      : isCurrent
                        ? "#d2660d"
                        : "#9aa0ac",
                  }}
                >
                  Step {stepNumber}
                </span>
              </div>

              {i < steps.length - 1 && (
                <div
                  style={{
                    height: "2px",
                    width: "40px",
                    flexShrink: 0,
                    backgroundColor:
                      isCompleted || completedSteps.includes(stepNumber + 1)
                        ? "#1e8a4c"
                        : "#eceef3",
                    marginBottom: "20px",
                    transition: "background-color 0.2s ease",
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default StepProgress;
